<template>
  <div class="t_table">
    <table border="1">
      <tr>
        <th v-for="(item,index) in thData"
            :key="index">{{item}}</th>
      </tr>
      <tr v-for="(item,index) in data"
          :key="index">
        <th>{{item.label+' 邮编'}}</th>
        <td v-for="(item_1,index_1 ) in item.value"
            :key="index_1">{{item_1}}</td>
      </tr>

    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: {
    data: {
      type: Array,
      requirt: false,
      defalut: []
    },
    thData: {
      type: Array,
      requirt: false,
      defalut: []
    }
  }
}
</script>

<style lang="scss">
.t_table {
  margin: 20px 0;
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    td {
      text-align: center;
    }
  }
}
</style>